import { createSelector } from 'reselect';

import {
  allCheckedGradesSelector,
  currentExamSelector,
  examsListAvailableSelector,
  showOnlyIncorrectSelector
} from '../../store/examData/selectors';
import { appealSearchBlocksNextStep } from '../../store/appealFind/selectors';

/**
 *  Возвращает набор данных для таблицы коррекции
 */
export default createSelector(
  examsListAvailableSelector,
  currentExamSelector,
  allCheckedGradesSelector,
  appealSearchBlocksNextStep,
  showOnlyIncorrectSelector,
  (
    examsListAvailable,
    currentExam,
    checkedGrades,
    blockedByAppealSearch,
    showOnlyIncorrectByGrade
  ) => ({
    examsListAvailable,
    currentExam,
    checkedGrades,
    blockedByAppealSearch,
    showOnlyIncorrectByGrade
  })
);
